import { createContext } from 'react'

const jobsContext = createContext();

export default jobsContext;